import { parseStringToUnit } from 'src/utils/parseStringToUnit.ts';
import { Unit } from 'uom';
import { Comparator, ComparatorItem } from 'src/common/types/Comparator.ts';
import { compareAsNumbers } from 'src/sensors/list/comparAsNumbers.ts';

export const initComparatorWithConversion = <T>(targetUnit: Unit.Unit<T>): Comparator => (
    a: ComparatorItem,
    b: ComparatorItem,
) => {
    try {
        const [parsedA] = parseStringToUnit(a.value);

        const [parsedB] = parseStringToUnit(b.value);

        if (!parsedA || !parsedB) {
            return compareAsNumbers(a.value, b.value);
        }
        const normalizedA = Unit.convert(
            parsedA.value,
            parsedA.unit,
            targetUnit,
        );

        const normalizedB = Unit.convert(
            parsedB.value,
            parsedB.unit,
            targetUnit,
        );

        return normalizedA > normalizedB ? 1 : -1;
    } catch {
        return 0;
    }
};
